import { useCallback, useEffect, useRef } from 'react';

// Taken from https://stackoverflow.com/a/57335271/1936629
export function useDebouncedCallback<A extends any[]>(
    callback: (...args: A) => void,
    wait: number
) {
    // track args & timeout handle between calls
    const argsRef = useRef<A>();
    const timeout = useRef<ReturnType<typeof setTimeout>>();

    const cleanup = useCallback(() => {
        if (timeout.current) {
            clearTimeout(timeout.current);
        }
    }, []);

    // make sure our timeout gets cleared if
    // our consuming component gets unmounted
    useEffect(() => cleanup, [cleanup]);

    return useCallback(
        (...args: A) => {
            // capture latest args
            argsRef.current = args;

            // clear debounce timer
            cleanup();

            // start waiting again
            timeout.current = setTimeout(() => {
                if (argsRef.current) {
                    callback(...argsRef.current);
                }
            }, wait);
        },
        [callback, cleanup, wait]
    );
}
